import { useState } from 'react'

import { useCurrentStatusStore } from 'store/currentStatusStore'
import { getAPI } from 'utils/getAPI'

import type {
  CompanyList,
  CreateCompanyCompanyCreatePostRequest,
  ReadCompanyCompanySearchGetRequest,
  ResponseResult,
  ResponseUpdate,
  UpdateCompanyCompanyUpdatePostRequest,
} from 'api-client'
import type { ErrorResponse } from 'types/types'

export const useCompany = () => {
  const [companySearch, setConpanySearch] = useState<CompanyList>({
    datacount: 0,
    maxcount: 0,
    lastUpdateDatetime: null,
    list: [],
  })
  const [compnaySearchIsLoading, setCompanySearchIsLoading] = useState(false)
  const [companyCreateIsLoading, setCompanyCreateIsLoading] = useState(false)
  const [companyUpdateIsLoading, setCompanyUpdateIsLoading] = useState(false)
  const [companySearchResult, setCompanySearchResult] = useState<ResponseResult | undefined>(undefined)
  const [companyCreateResult, setCompanyCreateResult] = useState<ResponseUpdate | undefined>(undefined)
  const [companyUpdateResult, setCompanyUpdateResult] = useState<ResponseUpdate | undefined>(undefined)
  const { setCurrentStatuses } = useCurrentStatusStore()

  const fetchCompanySearch = async (searchParam: ReadCompanyCompanySearchGetRequest) => {
    setCompanySearchIsLoading(true)

    try {
      const api = await getAPI()
      if (!api) return undefined

      const response = await api.readCompanyCompanySearchGet(searchParam)

      setConpanySearch(response.data)
      setCompanySearchResult(response.result)
      setCurrentStatuses(response.result.systemInfo?.sysCurrentStatus)
      return response
    } catch (e) {
      const error = e as ErrorResponse
      setCompanySearchResult({
        status: 'error',
        message: error.response && error.response.status === 422 ? '入力値に誤りがあります。' : `企業一覧取得でエラーが発生しました。`,
        systemDate: null,
        pageNo: 0,
        systemInfo: null,
      })
      return undefined
    } finally {
      setCompanySearchIsLoading(false)
    }
  }

  const fetchCompanyCreate = async (searchParam: CreateCompanyCompanyCreatePostRequest) => {
    setCompanyCreateIsLoading(true)

    try {
      const api = await getAPI()
      if (!api) return undefined

      const response = await api.createCompanyCompanyCreatePost(searchParam)

      setCompanyCreateResult(response)
      return response
    } catch (e) {
      const error = e as ErrorResponse
      setCompanyCreateResult({
        errors: [],
        result: {
          status: 'error',
          message: error.response && error.response.status === 422 ? '入力値に誤りがあります。' : `企業作成でエラーが発生しました。`,
          systemDate: null,
          pageNo: 0,
          systemInfo: null,
        },
        updateCount: null,
        lastUpdateDatetime: null,
      })
      return undefined
    } finally {
      setCompanyCreateIsLoading(false)
    }
  }

  const fetchCompanyUpdate = async (searchParam: UpdateCompanyCompanyUpdatePostRequest) => {
    setCompanyUpdateIsLoading(true)

    try {
      const api = await getAPI()
      if (!api) return undefined

      const response = await api.updateCompanyCompanyUpdatePost(searchParam)

      setCompanyUpdateResult(response)
      return response
    } catch (e) {
      const error = e as ErrorResponse
      setCompanyUpdateResult({
        errors: [],
        result: {
          status: 'error',
          message: error.response && error.response.status === 422 ? '入力値に誤りがあります。' : `企業更新でエラーが発生しました。`,
          systemDate: null,
          pageNo: 0,
          systemInfo: null,
        },
        updateCount: null,
        lastUpdateDatetime: null,
      })
      return undefined
    } finally {
      setCompanyUpdateIsLoading(false)
    }
  }

  return {
    companySearch,
    fetchCompanySearch,
    companySearchResult,
    compnaySearchIsLoading,

    fetchCompanyCreate,
    companyCreateResult,
    companyCreateIsLoading,

    fetchCompanyUpdate,
    companyUpdateResult,
    companyUpdateIsLoading,
  }
}
